import { ActionType, createAction, createReducer } from 'typesafe-actions';
import { ColorHoverState, ProductImageTag } from './types';

export const colorHoverAction = createAction('@PRODUCT_DETAILS/CHANGE_IMAGE_ON_HOVER', action => {
    return (isHover: boolean, imagePath: string, imageTag: ProductImageTag) => action({ isHover, imagePath, imageTag });
});

export const colorHoverActions = [colorHoverAction];

export type ColorHoverActionType = ActionType<typeof colorHoverAction>;

export const colorHoverDefaultState: ColorHoverState = {
    isHover: false,
    imagePath: '',
    imageTag: ProductImageTag.REGULAR,
};

export const colorHoverReducer = createReducer<ColorHoverState, ColorHoverActionType>(
    colorHoverDefaultState
).handleAction(colorHoverAction, (state, { payload: { isHover, imagePath, imageTag } }) => {
    return {
        ...state,
        isHover,
        imagePath,
        imageTag,
    };
});
